import { withI18n } from 'react-i18next';
import TrackingSearchBar from './TrackingSearchBar';

export const pureComponent = TrackingSearchBar;
export default withI18n()(TrackingSearchBar);
